<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M12 8.5a3.5 3.5 0 103.5 3.5A3.5 3.5 0 0012 8.5zm0 6a2.5 2.5 0 112.5-2.5 2.5 2.5 0 01-2.5 2.5z"/><path d="M21.18 11.07C20.17 9.76 16.5 5.5 12 5.5s-8.17 4.26-9.18 5.57a1.5 1.5 0 000 1.86c1 1.31 4.68 5.57 9.18 5.57s8.17-4.26 9.18-5.57a1.5 1.5 0 000-1.86zM12 16.5c-3.35 0-6.38-3.3-7.37-4.5 1-1.2 4-4.5 7.37-4.5s6.38 3.3 7.37 4.5c-.99 1.2-4.02 4.5-7.37 4.5z"/></svg>